import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfirmProvider } from "@/context/ConfirmContext";
import Dashboard from "@/pages/Dashboard";
import Production from "@/pages/Production";
import Haft from "@/pages/Haft";
import ForcePinChange from "@/pages/ForcePinChange";
import ShopApp from "@/pages/shop/ShopApp";
import SharedDrive from "@/pages/SharedDrive";
import MyStorePreview from "@/pages/shop/b2b/MyStorePreview";
import BackLink from "@/components/BackLink";

const LOGIN_PATH = "/sklep/logowanie";

function AdminPreviewGate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Ładowanie…</div>;
  if (!user) return <Navigate to="/sklep" replace />;
  return <MyStorePreview />;
}

function Gate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Ładowanie…</div>;
  if (!user) return <Navigate to="/sklep" replace />;
  if (user.must_change_pin) return <ForcePinChange />;
  return user.role === "production" ? <Production /> : user.role === "haft" ? <Haft /> : <Dashboard />;
}

export default function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <ConfirmProvider>
        <BrowserRouter>
          <BackLink />
          <Routes>
            <Route path="/login" element={<Navigate to={LOGIN_PATH} replace />} />
            <Route path="/realizacje" element={<Navigate to="/sklep/realizacje" replace />} />
            <Route path="/dysk/:token" element={<SharedDrive />} />
            <Route path="/podglad-sklepu/:storeId" element={<AdminPreviewGate />} />
            <Route path="/sklep/*" element={<ShopApp />} />
            <Route path="/*" element={<Gate />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
        </ConfirmProvider>
      </AuthProvider>
    </div>
  );
}
